"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M250 93.8C145.8 93.8 56.9 158.5 20.8 250c36 91.5 125 156.2 229.2 156.2S443.1 341.5 479.2 250C443.1 158.5 354.2 93.8 250 93.8zm0 260.4c-57.5 0-104.2-46.7-104.2-104.2S192.5 145.8 250 145.8 354.2 192.5 354.2 250 307.5 354.2 250 354.2zm0-166.7c-34.6 0-62.5 27.9-62.5 62.5s27.9 62.5 62.5 62.5 62.5-27.9 62.5-62.5-27.9-62.5-62.5-62.5z"
  });
};

exports.default = _default;